<div class="channels-container">
  <div class="items-container" *ngIf="channels">
    <div *ngFor="let item of channels">
      <app-channel-item
        [item]="item"
        (onUpdateChannel)="onUpdateChannel(item)"
        (onDeleteChannel)="onDeleteChannel(item)"
      >
      </app-channel-item>
    </div>
  </div>

  <div class="footer-container">
    <button
      mat-raised-button
      class="btn-create-channel background-primary-color"
      (click)="openFormDialog()"
    >
      + Criar canal
    </button>
  </div>
</div>
